export const onlyDefined = (array: Array<any>) => {
  return array.filter((element) => {
    // If the element is undefined or null, exclude it
    return element !== undefined && element !== null;
  });
};
